module.exports = __webpack_public_path__ + "img/round1.75d7dc74.png";